import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { Directive } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[strength]',
  providers: [{provide: NG_VALIDATORS, useExisting: StrengthValidatorDirective, multi: true}]
})
export class StrengthValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    if (control.value) {
      if (control.value.length < environment.minPassword) return {'strength': {value: 'validators.password.length.min'}};
      if (control.value.length > environment.maxStringLength) return {'strength': {value: 'validators.password.length.max'}};
      let valid = /[a-z]/.test(control.value);
      if (!valid) return {'strength': {value: 'validators.password.contain.lowercase'}};
      valid = /[A-Z]/.test(control.value);
      if (!valid) return {'strength': {value: 'validators.password.contain.uppercase'}};
      valid = /[0-9]/.test(control.value);
      if (!valid) return {'strength': {value: 'validators.password.contain.number'}};
      valid = /[@$%!^&*()_+{}:;<>,.?~]/.test(control.value);
      if (!valid) return {'strength': {value: 'validators.password.contain.special'}};
      return !valid ? {'strength': {value: control.value}} : null;
    }
  }
}
